import React from "react";
import { AvGroup } from "availity-reactstrap-validation";
import { StyledLabel } from "@aureskonnect/react-ui";

interface FormFieldProps {
    label: string;
    required?: boolean;
    error?: boolean;
    errorMessage?: string;
    secondError?: boolean;
    secondErrorMessage?: string;
    disabled?: boolean;
    className?: string;
    children: React.ReactNode;
    headerRight?: React.ReactNode;
}

export default function FormField({
    label,
    required = false,
    error = false,
    errorMessage = "",
    secondError = false,
    secondErrorMessage = "",
    disabled = false,
    className = "",
    children,
    headerRight,
}: FormFieldProps) {
    return (
        <AvGroup className={`${disabled ? "pe-none__clz" : ""} ${className}`}>
            <div className="d-flex justify-content-between mb-1">
                <StyledLabel
                    htmlFor="text"
                    className={`${required ? "required__clz" : ""} mt-3`}
                >
                    {label}
                </StyledLabel>
                {headerRight}
            </div>
            {children}
            {error && (
                <div
                    style={{
                        width: "100%",
                        marginTop: "0.25rem",
                        fontSize: "80%",
                        color: "#f46a6a",
                    }}
                >
                    {errorMessage}
                </div>
            )}
            {secondError && (
                <div
                    style={{
                        width: "100%",
                        marginTop: "0.25rem",
                        fontSize: "80%",
                        color: "#f46a6a",
                    }}
                >
                    {secondErrorMessage}
                </div>
            )}
        </AvGroup>
    );
}
